import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ISensor } from 'app/shared/model/sensor.model';
import { getEntities as getSensors } from 'app/entities/sensor/sensor.reducer';
import { ITruckImplement } from 'app/shared/model/truck-implement.model';
import { getEntities as getTruckImplements } from 'app/entities/truck-implement/truck-implement.reducer';
import { ICompany } from 'app/shared/model/company.model';
import { getEntities as getCompanies } from 'app/entities/company/company.reducer';
import { getEntity, updateEntity, createEntity, reset } from './sensor-data-daily.reducer';
import { ISensorDataDaily } from 'app/shared/model/sensor-data-daily.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const SensorDataDailyUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const sensors = useAppSelector(state => state.sensor.entities);
  const truckImplements = useAppSelector(state => state.truckImplement.entities);
  /* const companies = useAppSelector(state => state.company.entities); */
  const sensorDataDailyEntity = useAppSelector(state => state.sensorDataDaily.entity);
  const loading = useAppSelector(state => state.sensorDataDaily.loading);
  const updating = useAppSelector(state => state.sensorDataDaily.updating);
  const updateSuccess = useAppSelector(state => state.sensorDataDaily.updateSuccess);

  const handleClose = () => {
    props.history.push('/sensor-data-daily' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getSensors({}));
    dispatch(getTruckImplements({}));
    dispatch(getCompanies({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.created = convertDateTimeToServer(values.created);

    const entity = {
      ...sensorDataDailyEntity,
      ...values,
      sensor: sensors.find(it => it.id.toString() === values.sensorId.toString()),
      truckImplement: truckImplements.find(it => it.id.toString() === values.truckImplementId.toString()),
      /* company: companies.find(it => it.id.toString() === values.companyId.toString()), */
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          created: displayDefaultDateTime(),
        }
      : {
          ...sensorDataDailyEntity,
          created: convertDateTimeFromServer(sensorDataDailyEntity.created),
          sensorId: sensorDataDailyEntity?.sensor?.id,
          truckImplementId: sensorDataDailyEntity?.truckImplement?.id,
          /* companyId: sensorDataDailyEntity?.company?.id, */
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.sensorDataDaily.home.createOrEditLabel" data-cy="SensorDataDailyCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.sensorDataDaily.home.createOrEditLabel">Create or edit a SensorDataDaily</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="sensor-data-daily-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.sensorDataDaily.value')}
                id="sensor-data-daily-value"
                name="value"
                data-cy="value"
                type="text"
              />
              <ValidatedField
                label={translate('fleetSenseApp.sensorDataDaily.created')}
                id="sensor-data-daily-created"
                name="created"
                data-cy="created"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                id="sensor-data-daily-sensor"
                name="sensorId"
                data-cy="sensor"
                label={translate('fleetSenseApp.sensorDataDaily.sensor')}
                type="select"
              >
                {isNew ? <option value="" key="0" /> : null}
                {sensors
                  ? sensors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.description}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="sensor-data-daily-truckImplement"
                name="truckImplementId"
                data-cy="truckImplement"
                label={translate('fleetSenseApp.sensorDataDaily.truckImplement')}
                type="select"
              >
                {isNew ? <option value="" key="0" /> : null}
                {truckImplements
                  ? truckImplements.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.licensePlate}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              {/* <ValidatedField
                id="sensor-data-daily-company"
                name="companyId"
                data-cy="company"
                label={translate('fleetSenseApp.sensorDataDaily.company')}
                type="select"
              >
                <option value="" key="0" />
                {companies
                  ? companies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.name}
                      </option>
                    ))
                  : null}
              </ValidatedField> */}
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/sensor-data-daily" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default SensorDataDailyUpdate;
